import { useMemo } from 'react'

import { routes, useLocation, useParams } from '@redwoodjs/router'

import ApplicantCompanyNavItem from 'src/components/Sidebar/ApplicantSidebar/ApplicantCompanyNavItem'
import HelpNavItem from 'src/components/Sidebar/HelpNavItem'
import Navigation, { NavElement } from 'src/components/Sidebar/Navigation/Navigation'
import UserProfileNavItem from 'src/components/Sidebar/UserProfileNavItem'
import { LayoutMode } from 'src/utils/layout'

import { SidebarPrimitive } from '../SidebarPrimitive'

type Props = {
  isNavGroupOpenMap: Map<string, boolean>
  layoutMode: LayoutMode
  onToggleNavGroupIsOpen: (key: string) => void
}
export const ApplicantSidebar = ({
  isNavGroupOpenMap,
  layoutMode,
  onToggleNavGroupIsOpen,
}: Props) => {
  const { pathname } = useLocation()
  const { recordUuid } = useParams()
  const recordPaths: string[] = useMemo(
    () => [routes.citizenRecords(), ...(recordUuid ? [routes.record({ recordUuid })] : [])],
    [recordUuid]
  )

  const navElements: NavElement[] = useMemo(
    () => [
      {
        icon: 'FaProjectDiagram',
        internalRoute: routes.citizenRecords(),
        isActive: recordPaths.includes(pathname),
        title: 'My Projects',
      },
      {
        icon: 'FaListCheck',
        internalRoute: routes.tasks(),
        isActive: pathname.includes(routes.tasks()),
        title: 'Tasks',
      },
      {
        icon: 'FaLocationDot',
        internalRoute: routes.applicantCityPick(),
        isActive: pathname === routes.applicantCityPick(),
        title: 'Places',
      },
      {
        icon: 'FaEye',
        internalRoute: routes.citizenInspections(),
        isActive: pathname === routes.citizenInspections(),
        title: 'Inspections',
      },
      {
        icon: 'FaDollarSign',
        internalRoute: routes.citizenPayments(),
        isActive: pathname === routes.citizenPayments(),
        title: 'Payments',
      },
    ],
    [pathname, recordPaths]
  )

  return (
    <SidebarPrimitive layoutMode={layoutMode}>
      <SidebarPrimitive.Header />
      <SidebarPrimitive.Content>
        <Navigation elements={navElements} />
      </SidebarPrimitive.Content>
      <SidebarPrimitive.Footer>
        <UserProfileNavItem />
        <ApplicantCompanyNavItem
          isNavGroupOpenMap={isNavGroupOpenMap}
          onToggleNavGroupIsOpen={onToggleNavGroupIsOpen}
        />
        <HelpNavItem
          isNavGroupOpenMap={isNavGroupOpenMap}
          onToggleNavGroupIsOpen={onToggleNavGroupIsOpen}
        />
      </SidebarPrimitive.Footer>
    </SidebarPrimitive>
  )
}
